@if (didYouMean) {
<span class="spelling-suggestion"
  >{{ 'customSearch.didYouMeanLabel' | cxTranslate
  }}<a [routerLink]="['/search/', didYouMean.suggestion]">{{ didYouMean.suggestion }}</a
  >?</span
>
} @if (!didYouMean && searchBoxSuggestions && showSearchInstead(searchBoxSuggestions, searchBoxQuery)) {
<ul class="search-suggestion">
  {{
    'customSearch.searchBoxSuggestionsLabel' | cxTranslate
  }}
  @for (suggestion of searchBoxSuggestions; track suggestion) {
  <li>
    <a [routerLink]="['/search/', suggestion]">{{ suggestion }}</a>
  </li>
  }
</ul>
}
